import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const postApiConfigReportTest = async(sendData) => {
    if( !checkPermission('postApiConfigReportTest', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/report/test`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigEndpointEmailTest = async(sendData) => {
    if( !checkPermission('postApiConfigEndpointEmailTest', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint/email/test`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigEndpointTeamsTest = async(sendData) => {
    if( !checkPermission('postApiConfigEndpointTeamsTest', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint/teams/test`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigEndpointSlackTest = async(sendData) => {
    if( !checkPermission('postApiConfigEndpointSlackTest', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint/slack/test`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiConfigEndpointTelegramTest = async(sendData) => {
    if( !checkPermission('postApiConfigEndpointTelegramTest', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/config/endpoint/telegram/test`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                'accept' : 'application/json',
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}